<app-header [route]="'home'"></app-header>

<ion-content class="emr-bg">
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10">
        <!-- Print Button Header -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h3 class="text-primary fw-bold mb-0">
            <svg width="24" height="24" fill="none" stroke="#2C5695" stroke-width="2" viewBox="0 0 24 24">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <path d="M8 7h8M8 11h8M8 15h4"/>
            </svg>
            EMR Report
          </h3>
          <div>
            <button class="btn btn-primary btn-sm me-2" (click)="downloadPdf()">
              <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" class="me-1">
                <path d="M12 2v12m0 0l-3-3m3 3l3-3M3 12v7a2 2 0 002 2h14a2 2 0 002-2v-7"/>
              </svg>
              Download
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="printEmr()">
              <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" class="me-1">
                <rect x="6" y="9" width="12" height="7" rx="2"/>
                <path d="M6 17v2a2 2 0 002 2h8a2 2 0 002-2v-2"/>
                <path d="M6 9V7a2 2 0 012-2h8a2 2 0 012 2v2"/>
                <path d="M9 13h6"/>
              </svg>
              Print
            </button>
          </div>
        </div>

        <div class="card shadow rounded-4 mb-4 border-0 emr-report-card" #printSection>
          <div class="card-body p-4">
            <!-- Patient Information Header -->
            <div class="mb-4">
              <div class="row">
                <div class="col-md-6" *ngIf="patientInfo">
                  <h2 class="text-primary mb-1">{{patientInfo.FirstName + ' ' + (patientInfo.MiddleName || '')  + ' '+ patientInfo.LastName}}</h2>
                  <div class="d-flex flex-wrap gap-3">
                    <span><strong>Age:</strong> {{patientInfo.Age || 'N/A'}} years</span>
                    <span><strong>Gender:</strong> {{patientInfo?.Gender?.description || patientInfo?.Gender || 'N/A'}}</span>
                  </div>
                </div>
                <div class="col-md-6 text-md-end">
                  <div class="mb-2">
                    <span class="badge bg-light text-dark fs-6 p-2">PRN No: {{patientInfo?.PrnNumber || 'N/A'}}</span>
                  </div>
                  <p class="mb-0 text-muted">Report Date: {{emrData.CreatedDateTime | date: 'longDate'}}</p>
                </div>
              </div>
            </div>

            <!-- Visit Information -->
            <div class="row mb-4">
              <div class="col-12">
                <h5 class="section-title mb-3"><i class="fas fa-info-circle me-2"></i>Visit Information</h5>
                <div class="row g-3">
                  <div class="col-6 col-md-3">
                    <div class="info-label"><i class="far fa-calendar-alt me-1"></i>Visit Date</div>
                    <div class="info-value">{{ emrData.CreatedDateTime | date: 'dd MMM yyyy, hh:mm a' }}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="info-label"><i class="fas fa-hashtag me-1"></i>OPD/IPD Number</div>
                    <div class="info-value">{{ emrData.OpdIpdId || 'N/A' }}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="info-label"><i class="fas fa-user-md me-1"></i>Doctor</div>
                    <div class="info-value">{{ doctorObj[emrData.doctorId] || 'N/A' }}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="info-label"><i class="fas fa-building me-1"></i>Department</div>
                    <div class="info-value">{{ departmentObj[emrData.departmentId] || 'N/A' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Clinical Information -->
            <div class="row mb-4">
              <!-- Left Column -->
              <div class="col-12 col-md-6">
                <!-- History -->
                <div class="clinical-section mb-3">
                  <h5 class="section-title"><i class="fas fa-history me-2"></i>History</h5>
                  <div class="clinical-content">
                    {{ emrData.history || 'No history recorded' }}
                  </div>
                </div>

                <!-- Complaints -->
                <div class="clinical-section mb-3" *ngIf="emrData.complaints && emrData.complaints.length">
                  <h5 class="section-title"><i class="fas fa-notes-medical me-2"></i>Complaints</h5>
                  <div class="clinical-content">
                    <ul class="mb-0">
                      <li *ngFor="let c of emrData.complaints">{{ c }}</li>
                    </ul>
                  </div>
                </div>

                <!-- Diagnosis -->
                <div class="clinical-section mb-3" *ngIf="emrData.emrDiagnosis && emrData.emrDiagnosis.length">
                  <h5 class="section-title"><i class="fas fa-diagnoses me-2"></i>Diagnosis</h5>
                  <div class="clinical-content">
                    <ul class="mb-0">
                      <li *ngFor="let x of emrData.emrDiagnosis">{{ x.diagnosisDescription }}</li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Right Column -->
              <div class="col-12 col-md-6">
                <!-- Vitals -->
                <div class="clinical-section mb-3">
                  <h5 class="section-title"><i class="fas fa-heartbeat me-2"></i>Vitals</h5>
                  <div class="clinical-content">
                    <div class="vitals-grid">
                      <div class="vital-item">
                        <div class="vital-label">Height</div>
                        <div class="vital-value">{{ emrData.height || 'N/A' }} cm</div>
                      </div>
                      <div class="vital-item">
                        <div class="vital-label">Weight</div>
                        <div class="vital-value">{{ emrData.weight || 'N/A' }} kg</div>
                      </div>
                      <div class="vital-item">
                        <div class="vital-label">BMI</div>
                        <div class="vital-value">{{ emrData.bmi || 'N/A' }}</div>
                      </div>
                      <div class="vital-item">
                        <div class="vital-label">BP</div>
                        <div class="vital-value">{{ emrData.bp || 'N/A' }}</div>
                      </div>
                      <div class="vital-item">
                        <div class="vital-label">Pulse</div>
                        <div class="vital-value">{{ emrData.pulse || 'N/A' }}</div>
                      </div>
                      <div class="vital-item">
                        <div class="vital-label">SPO2</div>
                        <div class="vital-value">{{ emrData.spo2 || 'N/A' }}%</div>
                      </div>
                      <div class="vital-item">
                        <div class="vital-label">Temperature</div>
                        <div class="vital-value">{{ emrData.temperature || 'N/A' }} °F</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Allergies -->
                <div class="clinical-section mb-3" *ngIf="emrData.foodAllergy || emrData.fruitsAllergy || emrData.otherAllergy">
                  <h5 class="section-title"><i class="fas fa-allergies me-2"></i>Allergies</h5>
                  <div class="clinical-content">
                    <ul class="mb-0">
                      <li *ngIf="emrData.foodAllergy"><strong>Food:</strong> {{ emrData.foodAllergy }}</li>
                      <li *ngIf="emrData.fruitsAllergy"><strong>Fruits:</strong> {{ emrData.fruitsAllergy }}</li>
                      <li *ngIf="emrData.otherAllergy"><strong>Other:</strong> {{ emrData.otherAllergy }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Investigations & Services -->
            <div class="row mb-4">
              <div class="col-12 col-md-6">
                <div class="clinical-section mb-3" *ngIf="emrData.cpoeInvestigation && emrData.cpoeInvestigation.length">
                  <h5 class="section-title"><i class="fas fa-vials me-2"></i>Investigations</h5>
                  <div class="clinical-content">
                    <ul class="mb-0">
                      <li *ngFor="let inv of emrData.cpoeInvestigation">
                        <strong>{{ inv.serviceName }}:</strong> {{ inv.remark || 'No remarks' }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="clinical-section mb-3" *ngIf="emrData.cpoeServices && emrData.cpoeServices.length">
                  <h5 class="section-title"><i class="fas fa-stethoscope me-2"></i>Services</h5>
                  <div class="clinical-content">
                    <ul class="mb-0">
                      <li *ngFor="let srv of emrData.cpoeServices">
                        <strong>{{ srv.serviceName }}:</strong> {{ srv.remark || 'No remarks' }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Advices -->
            <div class="row mb-4" *ngIf="emrData.advices && emrData.advices.length">
              <div class="col-12">
                <div class="clinical-section">
                  <h5 class="section-title"><i class="fas fa-lightbulb me-2"></i>Advices</h5>
                  <div class="clinical-content">
                    <ul class="mb-0">
                      <li *ngFor="let a of emrData.advices">{{ a }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Prescriptions -->
            <div class="row" *ngIf="emrData.emrPrescription && emrData.emrPrescription.length">
              <div class="col-12">
                <div class="clinical-section">
                  <h5 class="section-title"><i class="fas fa-prescription-bottle-alt me-2"></i>Prescriptions</h5>
                  <div class="clinical-content">
                    <div class="table-responsive">
                      <table class="table table-sm table-bordered">
                        <thead class="table-light">
                          <tr>
                            <th>Drug Name</th>
                            <th>Route</th>
                            <th>Frequency</th>
                            <th>Duration (Days)</th>
                            <th>Quantity</th>
                            <th>Instruction</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let p of emrData.emrPrescription">
                            <td>{{ p.drugName }}</td>
                            <td>{{ routeObj[p.routeId] | titlecase}}</td>
                            <td>{{ freqObj[p.frequencyId] }}</td>
                            <td>{{ p.duration }}</td>
                            <td>{{ p.quantity }}</td>
                            <td>{{ p.instruction || '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Doctor Signature -->
            <div class="row pb-5">
              <div class="col-12 text-end">
                <div class="signature-box">
                  <p class="mb-1">_________________________</p>
                  <p class="mb-0"><strong>Dr. {{doctorObj[emrData.doctorId] || 'Physician'}}</strong></p>
                  <p class="text-muted small">Medical Practitioner</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>